import React, { useState } from "react";
import cookie from "react-cookies";
import moment from "moment";
import { Modal } from "react-bootstrap";

import { updateDriverLicense, uploadPaper } from "../../model/profile";

import { commonErr } from "../common/errors";
import { LoadingInline } from "../common/loading";

import ImageUpload from "../common/imageupload";
import { MessageBox } from "../common/messagebox";
import { CustomInputLabelOutside } from "../components/input";

import { IcPencil, IcQuesMark, IcUpload } from "../common/svg";
import { LicenseForm } from "../car/components/verifybox";

const UploadLicenseImage = ({ edit, papers }) => {
	const [paper, setPaper] = useState(papers);

	const handleFileInputChange = (photos) => {
		setPaper({ ...paper, err: commonErr.LOADING });
		uploadPaper(paper.id, photos[0]).then((resp) => {
			var photosInput = [];
			if (paper.photos) {
				photosInput = photosInput.concat(paper.photos);
			}
			if (resp.data.data && resp.data.data.id) {
				photosInput.push(resp.data.data);
			}
			setPaper({
				...paper,
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				photos: photosInput,
			});
		});
	};

	const hidePaperMessageBox = () => {
		setPaper({
			...paper,
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	return (
		<div className="info-license">
			<div className="info-license__title">
				<p>Hình ảnh</p>
			</div>
			{paper?.photos?.length > 0 ? (
				<label className={`info-license__img ${edit ? "has-edit" : ""} `}>
					<div className="fix-img">
						<img
							loading="lazy"
							className="img-license"
							src={paper.photos && paper.photos[paper.photos.length - 1].url}
						/>
					</div>
					{edit && <ImageUpload withPreview={false} onChange={handleFileInputChange} />}
				</label>
			) : (
				<div className={`info-license__upload ${edit ? "has-edit" : ""} `}>
					<div className="wrap-svg">
						<IcUpload />
					</div>
					<p className="main">Chọn hình ảnh giấy phép</p>
					{edit && <ImageUpload withPreview={false} onChange={handleFileInputChange} />}
					{/* <p>Hình JPG và PNG - dung lượng tối đa 20MB mỗi tấm</p> */}
				</div>
			)}
			<MessageBox show={paper.err < commonErr.SUCCESS} hideModal={hidePaperMessageBox} message={paper.errMsg} />
		</div>
	);
};

const ModalVerifyLicense = ({ profile, status, step, err, errMsg, show, closeModal, retryVerify, openVerifyPhone }) => {
	var content;
	if (step === 1) {
		if (err === commonErr.LOADING) {
			content = (
				<div className="modal-input-body">
					<LoadingInline />
				</div>
			);
		} else if (err >= commonErr.SUCCESS) {
			const info = profile.info;
			switch (status) {
				case 1:
				case 3:
					content = (
						<div className="modal-input-body">
							<p className="font-14 text-success">Cập nhật thành công</p>
							<p className="font-14">Thông tin GPLX của bạn đã được xác thực thành công. Xin cảm ơn</p>
							{info.phoneVerified !== 1 && (
								<>
									<p className="font-14">Bạn cần xác thực thêm Số điện thoại để có thể đặt xe</p>
									<div className="wrap-btn">
										<a className="btn btn-primary btn--m" onClick={openVerifyPhone}>
											Cập nhật ngay
										</a>
									</div>
								</>
							)}
						</div>
					);
					break;
				case 2:
					content = (
						<div className="modal-input-body">
							<p className="font-14 text-success">Cập nhật thành công</p>
							<p className="font-14">Thông tin GPLX của bạn sẽ được Mioto xác thực trong thời gian sớm nhất.</p>
							<p className="font-14">Lưu ý, bạn vẫn có thể tiến hành đặt xe trong thời gian chờ xác thực. Xin cảm ơn</p>
							{info.phoneVerified !== 1 && (
								<>
									<p className="font-14">Bạn cần xác thực thêm Số điện thoại để có thể đặt xe</p>
									<div className="wrap-btn">
										<a className="btn btn-primary btn--m" onClick={openVerifyPhone}>
											Cập nhật ngay
										</a>
									</div>
								</>
							)}
						</div>
					);
					break;
				case 11:
					content = (
						<div className="modal-input-body">
							<p className="font-14 text-danger">Cập nhật thất bại</p>
							<p className="font-14">
								Mioto không tìm thấy thông tin GPLX của bạn trên hệ thống. Bạn vui lòng kiểm tra lại{" "}
								<span className="fontWeight-5">Số GPLX</span>, <span className="fontWeight-5">Ngày sinh</span> và tiến
								hành cập nhật lại.
							</p>
							<p className="font-14">
								Nếu vẫn không thể xác thực, vui lòng liên hệ Mioto để được hỗ trợ nhanh nhất. (Tổng đài 19009217 -
								9:00AM - 6:00PM T2-T7 hoặc gửi tin nhắn đến Mioto Fanpage)
							</p>
							<p className="font-14">
								Lưu ý: GPLX mới cấp trong vòng 30 ngày có thể chưa được cập nhật trên hệ thống GPLX trực tuyến.
							</p>
							<div className="wrap-btn">
								<a className="btn btn-primary btn--m" onClick={retryVerify}>
									Thử lại
								</a>
							</div>
						</div>
					);
					break;
			}
		} else {
			content = (
				<div className="modal-input-body">
					<p className="font-14 text-danger">Cập nhật thất bại. {errMsg}</p>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" onClick={retryVerify}>
							Thử lại
						</a>
					</div>
				</div>
			);
		}
	}

	return (
		<Modal show={show} onHide={closeModal} dialogClassName="modal-s modal-input">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Xác thực giấy phép lái xe</h5>
			</Modal.Header>
			<Modal.Body>{content}</Modal.Body>
		</Modal>
	);
};

const License = ({ licenseStt, driverLicense, profile, showVerifyPhone }) => {
	const [showGuide, setShowGuide] = useState(false);
	const [state, setState] = useState({
		licenseNumber: driverLicense.licenseNumber,
		licenseName: driverLicense.licenseName,
		dob:
			driverLicense.dob > 0
				? moment(driverLicense.dob).format("DD-MM-YYYY")
				: profile.dob > 0
				? moment(profile.dob).format("DD-MM-YYYY")
				: "01-01-1970",
		papers: driverLicense.papers[0],
		edit: false,
		isLicenseNumberValid: true,
		isLicenseNameValid: true,
		isDobValid: true,
		isPaperPhotosValid: true,
		alertMsgLicenseNumber: "",
		alertMsgLicenseName: "",
		alertMsgDob: "",
		alertMsgPhotos: "",
		showModal: false,
		status: 0,
		err: commonErr.INNIT,
		errMsg: "",
		step: 0,
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setState({ ...state, [name]: value });
	};

	const handleEditClick = () => {
		setState({ ...state, edit: !state.edit });
	};

	const refreshCheckFilled = () => {
		setState({
			...state,
			isLicenseNumberValid: true,
			isLicenseNameValid: true,
			isDobValid: true,
			isPaperPhotosValid: true,
			alertMsg: "",
		});
	};

	const isValidSubmit = () => {
		refreshCheckFilled();
		if (state.licenseNumber === "" || !state.licenseNumber) {
			setState({
				...state,
				isLicenseNumberValid: false,
				alertMsgLicenseNumber: "Bạn chưa điền số GPLX",
			});
			return false;
		}
		if (state.licenseName === "" || !state.licenseName) {
			setState({
				...state,
				isLicenseNameValid: false,
				alertMsgLicenseNumber: "",
				alertMsgLicenseName: "Bạn chưa điền họ tên",
			});
			return false;
		}
		if (state.dob.includes("_") || !moment(`${state.dob}`, "DD-MM-YYYY").isValid()) {
			setState({
				...state,
				isDobValid: false,
				alertMsgLicenseNumber: "",
				alertMsgLicenseName: "",
				alertMsgDob: "Ngày tháng năm sinh không hợp lệ",
			});
			return false;
		}
		if (!state.papers.photos || state.papers.photos === undefined) {
			setState({
				...state,
				isPaperPhotosValid: false,
				alertMsgLicenseNumber: "",
				alertMsgLicenseName: "",
				alertMsgDob: "",
				alertMsgPhotos: "Bạn chưa cập nhật hình ảnh giấy phép lái xe",
			});
			return false;
		}
		return true;
	};

	const onSubmitBtnClick = () => {
		if (!isValidSubmit()) {
			// ...
		} else {
			setState({
				...state,
				step: 1,
				err: commonErr.LOADING,
			});

			const profile = {
				licenseNumber: state.licenseNumber,
				licenseName: state.licenseName,
				dob: moment(`${state.dob}`, "DD-MM-YYYY").valueOf(),
			};

			updateDriverLicense(profile).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					setState({
						...state,
						step: 1,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						status: resp.data.data.driverLicenseStatus,
						edit: false,
						showModal: true,
						alertMsgLicenseNumber: "",
						alertMsgLicenseName: "",
						alertMsgDob: "",
						alertMsgPhotos: "",
					});

					//GA
					const utmSrc = cookie.load("_utm_src") || "web_directly";
					const utmExt = cookie.load("_utm_ext") || "no_label";

					"event",
						"VERIFY_DRIVER_LICENSE_SUCCESS",
						{
							event_category: utmSrc,
							event_label: utmExt,
						};
				} else {
					setState({
						...state,
						step: 1,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};

	const closeModal = () => {
		setState({
			...state,
			showModal: false,
			edit: false,
		});
	};

	const retryVerify = () => {
		setState({
			...state,
			showModal: false,
			edit: true,
		});
	};

	const openVerifyPhone = () => {
		showVerifyPhone();
		setState({
			...state,
			showModal: false,
		});
	};

	const noChangeFillClick = () => {
		setState({
			...state,
			licenseNumber: driverLicense.licenseNumber,
			licenseName: driverLicense.licenseName,
			dob:
				driverLicense.dob > 0
					? moment(driverLicense.dob).format("DD-MM-YYYY")
					: profile.dob > 0
					? moment(profile.dob).format("DD-MM-YYYY")
					: "01-01-1970",
			edit: false,
			alertMsgLicenseNumber: "",
			alertMsgLicenseName: "",
			alertMsgDob: "",
			alertMsgPhotos: "",
		});
	};

	return (
		<div className="content-item driver-license">
			<div className="title">
				<div className="title-item">
					<h6>Giấy phép lái xe</h6>
					<div className={`title-item__info ${licenseStt.clg}`}>
						<div className="wrap-svg">{licenseStt.ic}</div>
						{licenseStt.name}
					</div>
				</div>
				{state.err === commonErr.LOADING ? (
					<LoadingInline />
				) : state.edit ? (
					<div className="wrap-btn has-2-btn" style={{ paddingTop: "0", width: "unset" }}>
						<a onClick={noChangeFillClick} className="btn btn-cancel">
							Huỷ
						</a>
						<a onClick={onSubmitBtnClick} className="btn btn--s btn-primary">
							Cập nhật
						</a>
					</div>
				) : (
					<a onClick={handleEditClick} className="btn btn--s">
						Chỉnh sửa
						<div className="wrap-svg">
							<IcPencil />
						</div>
					</a>
				)}
			</div>
			<div className="learn-more">
				<p>Vì sao tôi phải xác thực GPLX</p>
				<div className="wrap-svg" onClick={() => setShowGuide(true)}>
					<IcQuesMark />
				</div>
			</div>
			<div className="content">
				<div className="info-license">
					<div className="info-license__title">
						<p>Thông tin chung</p>
					</div>
					<CustomInputLabelOutside
						placeholder={"Nhập số GPLX đã cấp"}
						type={"text"}
						name={"licenseNumber"}
						label={"Số GPLX"}
						value={state.licenseNumber}
						onChange={handleInputChange}
						disabled={!state.edit}
						valid={state.isLicenseNumberValid ? "success" : "error"}
						status={state.alertMsgLicenseNumber}
					/>
					<CustomInputLabelOutside
						placeholder={"Nhập đầy đủ họ tên"}
						type={"text"}
						name={"licenseName"}
						label={"Họ và tên"}
						value={state.licenseName}
						onChange={handleInputChange}
						disabled={!state.edit}
						valid={state.isLicenseNameValid ? "success" : "error"}
						status={state.alertMsgLicenseName}
					/>
					<CustomInputLabelOutside
						placeholder={"Nhập ngày sinh"}
						type={"text"}
						name={"dob"}
						label={"Ngày sinh"}
						value={state.dob}
						onChange={handleInputChange}
						disabled={!state.edit}
						inputMask={true}
						valid={state.isDobValid ? "success" : "error"}
						status={state.alertMsgDob}
					/>
				</div>
				<UploadLicenseImage edit={state.edit} papers={state.papers} />
			</div>
			<ModalVerifyLicense
				profile={profile}
				status={state.status}
				step={state.step}
				err={state.err}
				errMsg={state.errMsg}
				show={state.showModal}
				closeModal={closeModal}
				retryVerify={retryVerify}
				openVerifyPhone={openVerifyPhone}
			/>
			<LicenseForm
				show={showGuide}
				onHide={() => setShowGuide(false)}
				showChangeDriverLicense={() => setShowGuide(false)}
			/>
		</div>
	);
};

export default License;
